var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"streetViewMap"},[_c('gmap-street-view-panorama',{staticClass:"pano",attrs:{"position":_vm.location,"pov":_vm.street_pov,"options":_vm.streetOptions},on:{"pano_changed":_vm.updatePano,"pov_changed":_vm.updatePov,"position_changed":_vm.updateLatLng}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }